import { TimesheetInterface } from '../../../interfaces/timesheet.interface';

export class PickTimesheet {
    public static readonly type = '[JobsPlacements] Pick a timesheet';

    constructor(public timesheet: TimesheetInterface | null) { }
}
